module.exports = {
  background: '#FFFFFF',
  // light triangle
  backgroundDark: '#EFF6E0',

  // text color
  primary: '#01161E',
  // underline color
  primaryLight: '#FE7F2D',
  // right tri
  primaryDark: '#124559',

  // left tri
  secondary: '#5398BE',
  // bot tri
  secondaryLight: '#EFF6E0',
  secondaryDark: '#01161E',
};
